/** @jsxImportSource @emotion/react */
import { LOCALE_KEY } from './const';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Separator } from './imgs/separator.svg';

// import { Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import style from './style';

interface PropsType {
    title: string;
}

const RouteBreadcrumbView = (_props: PropsType) => {
    const { t } = useTranslation(LOCALE_KEY);

    return (
        <div css={style.base}>
            <Breadcrumb separator={<Separator />}>
                <Breadcrumb.Item>{t('home')}</Breadcrumb.Item>
                <Breadcrumb.Item>{t('listing')}</Breadcrumb.Item>
            </Breadcrumb>
        </div>
    );
};

export default RouteBreadcrumbView;
